import { gql } from '@apollo/client';

export const ASK_DOCUMENT = gql`
  mutation AskDocument(
    $question: String!
    $scope: String
    $documentId: ID
    $dealId: ID
    $sessionToken: String
    $includeAudio: Boolean
    $voiceName: String
    $speakingRate: Float
  ) {
    askDocument(
      question: $question
      scope: $scope
      documentId: $documentId
      dealId: $dealId
      sessionToken: $sessionToken
      includeAudio: $includeAudio
      voiceName: $voiceName
      speakingRate: $speakingRate
    ) {
      answer
      sources
      sessionToken
      chunksUsed
      modelUsed
      audioResponse
      scopeInfo
    }
  }
`;